export const Popover = {
  baseStyle: {
    content: {
      borderRadius: '12px',
      borderWidth: '1px',
      borderColor: 'light.border',
      boxShadow: 'light.primary',
      _focus: { outline: 'none', boxShadow: 'light.primary' },
      _active: { outline: 'none', boxShadow: 'light.primary' },
    },
  },
};
